import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroBanner } from './components/HeroBanner';
import { WelcomeSection } from './components/WelcomeSection';
import { PopularTours } from './components/PopularTours';
import { WhyChooseUs } from './components/WhyChooseUs';
import { PopularHotels } from './components/PopularHotels';
import { Reviews } from './components/Reviews';
import { BlogSection } from './components/BlogSection';
import { Footer } from './components/Footer';
import { EverestTrekPage } from './pages/EverestTrekPage';
import { HotelPage } from './pages/HotelPage';
import { LuxuryToursPage } from './pages/LuxuryToursPage';
import { HotelsRegionPage } from './pages/HotelsRegionPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PlanTripPage } from './pages/PlanTripPage';
import { SearchPage } from './pages/SearchPage';
import { BlogPage } from './pages/BlogPage';
import { GuidePage } from './pages/GuidePage';
type PageType = 'home' | 'everest-trek' | 'dwarika-hotel' | 'luxury-tours' | 'hotels-everest' | 'hotels-pokhara' | 'hotels-nagarkot' | 'about' | 'contact' | 'plan-trip' | 'search' | 'blog' | 'guide-rajesh' | 'guide-sita' | 'guide-pemba' | 'guide-maya';
const heroPages: PageType[] = ['home', 'everest-trek', 'luxury-tours', 'hotels-everest', 'hotels-pokhara', 'hotels-nagarkot', 'about', 'contact', 'plan-trip', 'blog', 'guide-rajesh', 'guide-sita', 'guide-pemba', 'guide-maya'];
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('home');
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [currentPage]);
  const handleNavigate = (page: string) => {
    setCurrentPage(page as PageType);
  };
  const needsForceScrolled = !heroPages.includes(currentPage) || currentPage === 'dwarika-hotel';
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar forceScrolled={needsForceScrolled} onNavigate={handleNavigate} data-id="element-1" />

      {currentPage === 'home' && <>
          <HeroBanner data-id="element-2" />
          <WelcomeSection data-id="element-3" />
          <PopularTours onNavigate={handleNavigate} data-id="element-4" />
          <WhyChooseUs data-id="element-5" />
          <PopularHotels onNavigate={handleNavigate} data-id="element-6" />
          <Reviews data-id="element-7" />
          <BlogSection onNavigate={handleNavigate} data-id="element-8" />
        </>}

      {currentPage === 'everest-trek' && <EverestTrekPage onNavigate={handleNavigate} data-id="element-9" />}

      {currentPage === 'dwarika-hotel' && <HotelPage onNavigate={handleNavigate} data-id="element-10" />}

      {currentPage === 'luxury-tours' && <LuxuryToursPage onNavigate={handleNavigate} data-id="element-11" />}

      {(currentPage === 'hotels-everest' || currentPage === 'hotels-pokhara' || currentPage === 'hotels-nagarkot') && <HotelsRegionPage regionKey={currentPage} onNavigate={handleNavigate} data-id="element-12" />}

      {currentPage === 'about' && <AboutPage onNavigate={handleNavigate} data-id="element-13" />}

      {currentPage === 'contact' && <ContactPage onNavigate={handleNavigate} data-id="element-14" />}

      {currentPage === 'plan-trip' && <PlanTripPage onNavigate={handleNavigate} data-id="element-15" />}

      {currentPage === 'search' && <SearchPage onNavigate={handleNavigate} data-id="element-16" />}

      {currentPage === 'blog' && <BlogPage onNavigate={handleNavigate} data-id="element-17" />}

      {(currentPage === 'guide-rajesh' || currentPage === 'guide-sita' || currentPage === 'guide-pemba' || currentPage === 'guide-maya') && <GuidePage guideKey={currentPage} onNavigate={handleNavigate} data-id="element-18" />}

      <Footer data-id="element-19" />
    </div>;
}